export const verifiedAddress = [
    '3PPgeYTWMRZ7S7jSLpnVuKKB9r6XuDk3ndC', // sign art wrapper
    '3P3pDosq4GCwfJkvq4yqKvvoTwmoqc9qPmo', // ducks wrapper
    '3PMki5sHBsQb4KgDknbUwsL3YgxaCzaZnCJ', // bored ania creator
    '3PFkgvC9y6zHy64zEAscKKgaNY3yipiLqbW', // puzzle pool artefacts
    '3P3iV85eXfkcA3Dd13EpZBYvs1vkKX6AYEN',
    '3PHFAavxj2ePJqFB46H2aRGA7oQL6kz1rJJ',
    '3P6peovAkVN3px6Zuv8y2noTWHFM4R5Wjj8',
    '3P5CQkvk8Pu6rGP3Qav4Lwskwa8pLhNwTbR',
    '3PHKDCQScvSPHvdCUeucFkx5Q1xMURA9kbr', // MonsterHunt
    '3PGGSiLuwGmm7ChfjDrmEZBd6HxQJn8N1NM', // Puzzle Ducks
    '3PKHFX6W4aAr1e1b8MUTz5HmdWVUcjWhgY4',
    '3P8rLVnwrTf4k5AB3emuduhZZb1yKcitTHy', // Waves Punks
    '3P7QrWH1ETLfKAJcFHYPJmQusNbDuW98Hop', // Waves Punks Zombie
    '3PBkrb5LrGDvCwkx4VHZzZkqMNvvGqrJJWj', // Waves Punks Memaliens
    '3PD1sd55PYzmGUrQ896Qt3uvdbtgjCVpajE', // Waves Punks Wrapper
    '3PKVgd6ds1xervK6bPXbEHBqg8ibTcf5HZk', // Ultra staking wrapper
    '3P5d8a1H2m2zFQakhaaow3uDE77UYLGd89v', // pluto eagles
    '3P4m4beJ6p1pMPHqCQMAXEdquUuXJz72CMe', // clef
    '3PLncXtS1U83D6cQbFD3H8rBHPLgzxSFKZ1', // Waves lands issuer
    '3PCW9q51iwFiaDZB8SSRgc7jqjYgTgQy5T3', // Waves lands wrapper
    '3PPLea51cvcmmLAhMqT7r4VmarDMf7Y5iVH', // Tsunami nft
    '3P975LUuqc7uBPiSxp3nemf2FZh62zfirSh', // DAO
];

export const verifiedCollections = [
    "3PPgeYTWMRZ7S7jSLpnVuKKB9r6XuDk3ndC_signArt", // Sign Art
    "3P3pDosq4GCwfJkvq4yqKvvoTwmoqc9qPmo_ducks", // Waves ducks
    // "eagles", // Eagles
    "3PCW9q51iwFiaDZB8SSRgc7jqjYgTgQy5T3_WavesLands", // Waves Lands
    "3P5d8a1H2m2zFQakhaaow3uDE77UYLGd89v_PLUTO EAGLES", // Pluto Eagles
    "3PMki5sHBsQb4KgDknbUwsL3YgxaCzaZnCJ_ania", // Bored Ania
    "3PKVgd6ds1xervK6bPXbEHBqg8ibTcf5HZk_ania", // Bored Ania
    "3PKVgd6ds1xervK6bPXbEHBqg8ibTcf5HZk_signArt", // Eagles
    "3PFkgvC9y6zHy64zEAscKKgaNY3yipiLqbW_Puzzle Pool Artefact", // Puzzle Pool Artefact
    "3P5CQkvk8Pu6rGP3Qav4Lwskwa8pLhNwTbR_Puzzle Gang Avangard", // Puzzle Gang Avangard
    "3P6peovAkVN3px6Zuv8y2noTWHFM4R5Wjj8_Puzzle Eagles", // Puzzle Eagles
    "3P4m4beJ6p1pMPHqCQMAXEdquUuXJz72CMe_Clef genesis songs", // Clef
    "3P4m4beJ6p1pMPHqCQMAXEdquUuXJz72CMe_basic", // Clef
    "3P4m4beJ6p1pMPHqCQMAXEdquUuXJz72CMe_Clef mixes", // Clef
    "3P3iV85eXfkcA3Dd13EpZBYvs1vkKX6AYEN_erics charity collection", // Charity collection
    '3PHKDCQScvSPHvdCUeucFkx5Q1xMURA9kbr_MonsterHunt Alpha Monsters', // MonsterHunt
    "3PHKDCQScvSPHvdCUeucFkx5Q1xMURA9kbr_MonsterHunt", // MonsterHunt
    '3PGGSiLuwGmm7ChfjDrmEZBd6HxQJn8N1NM_Puzzle Ducks', // Puzzle Ducks
    '3PD1sd55PYzmGUrQ896Qt3uvdbtgjCVpajE_WavesPunks Zombie', // WavesPunks
    "3PD1sd55PYzmGUrQ896Qt3uvdbtgjCVpajE_WavesPunks", // WavesPunks
    "3PD1sd55PYzmGUrQ896Qt3uvdbtgjCVpajE_WavesPunks Memaliens", // WavesPunks
    "3PD1sd55PYzmGUrQ896Qt3uvdbtgjCVpajE_WavesMadPunks", // WavesPunks
    '3PKHFX6W4aAr1e1b8MUTz5HmdWVUcjWhgY4_The beginning of the Puzzle', // The beginning of the Puzzle
    "3PGKEe4y59V3WLnHwPEUaMWdbzy8sb982fG_.waves", // waves domains
    "3PPLea51cvcmmLAhMqT7r4VmarDMf7Y5iVH_Surf the Fees", // Tsunami nft
    "3P975LUuqc7uBPiSxp3nemf2FZh62zfirSh_Market DAO Dragons", // DAO Dragons
]

export enum ASSET_ID {
    WAVES = 'WAVES',
    PUZZLE = 'HEB8Qaw9xrWpWs8tHsiATYGBWDBtP2S7kcPALrMu43AS',
    USDN = 'DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p',
    EGG = 'C1iWsKGqLwjHUndiQ7iXpdmPum9PeCDFfyXBdJJosDRS',
    USDT_WX = '34N9YcEETLWn93qYQ64EsP1x89tSruJU44RrEMSXXEPJ',
    USDC_WX = '6XtHjpXbs9RRJP2Sr9GUyVqzACcby9TkThHXnjVC5CDJ',
    USDT = '9wc3LXNA4TEBsXyKtoLE9mrbDD7WMHXvXrCjZvabLAsi',
    USDC = 'HGgabTqUS8WtVFUJzfmrTDMgEccJuZLBPhFgQFxvnsoW',
    PETE = 'GAzAEjApmjMYZKPzri2g2VUXNvTiQGF7KDYZFFsP3AEq',
}

export const tokenInfo: any = {
    WAVES: {
        id: ASSET_ID.WAVES,
        title: 'Waves',
        decimals: 100000000
    },
    HEB8Qaw9xrWpWs8tHsiATYGBWDBtP2S7kcPALrMu43AS: {
        id: ASSET_ID.PUZZLE,
        title: 'Puzzle',
        decimals: 100000000
    },
    DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p: {
        id: ASSET_ID.USDN,
        title: 'USDN',
        decimals: 1000000
    },
    C1iWsKGqLwjHUndiQ7iXpdmPum9PeCDFfyXBdJJosDRS: {
        id: ASSET_ID.EGG,
        title: 'EGG',
        decimals: 100000000
    },
    '34N9YcEETLWn93qYQ64EsP1x89tSruJU44RrEMSXXEPJ': {
        id: ASSET_ID.USDT_WX,
        title: 'USDT',
        decimals: 1000000
    },
    '6XtHjpXbs9RRJP2Sr9GUyVqzACcby9TkThHXnjVC5CDJ': {
        id: ASSET_ID.USDC_WX,
        title: 'USDC',
        decimals: 1000000
    },
    '9wc3LXNA4TEBsXyKtoLE9mrbDD7WMHXvXrCjZvabLAsi': {
        id: ASSET_ID.USDT,
        title: 'USDT',
        decimals: 1000000
    },
    'HGgabTqUS8WtVFUJzfmrTDMgEccJuZLBPhFgQFxvnsoW': {
        id: ASSET_ID.USDC,
        title: 'USDC',
        decimals: 1000000
    },
    GAzAEjApmjMYZKPzri2g2VUXNvTiQGF7KDYZFFsP3AEq: {
        id: ASSET_ID.PETE,
        title: 'PETE',
        decimals: 100000000
    }
};